export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL;
export const IP_API_URL = process.env.REACT_APP_IP_API_URL;
export const PDF_API_URL = process.env.REACT_APP_PDF_API_URL;

export const BASE_API_ROUTES = {
  createTaxRate: `${BASE_API_URL}/CC_API/CreateTaxRate`,
  getAllIntegrationsByTechType: `${BASE_API_URL}/CC_API/GetAllIntegrationsByTechologyType`
}

export const BASE_API_PAGE_ENUMS = {
  getMspDetails: 26,
  removePortlandReport: 27,
  GetTaxesList: 99,
  QuestionNote: 261,
  ToolToYes: 262,
  GetClientAccessRolesDetails: 551,
  GetClientAccessDetails: 553,
  GetAccessRolesDetails: 561,
  GetMemberDetails: 563,
  GetSecurityStackView: 608,
  IntegrationByTechType: 985,
  RemoveIntegration: 987,
  CheckToolInUse: 988,
  DeleteIntegration: 1055,
  GetAllTechsByIntegration: 1060,
  GetSecurityStackHeaderView: 1091,
  RecalculateGovResScore: 1099,
  RecalculateServicePackageScore: 1103,
  GetAddToolsForStack: 1104,
  GetToolsInMyStack: 1106,
  GetToolInfo: 1107,
  RemoveToolFromStack: 1108,
  RemovePracticeTool: 1109,
  GetPracticeTypes: 1111,
}

export const BASE_API_PATHS = {
  overviewDashboard: "Overview",
  suspendAccount: "SuspendAccount",
  initiateSession: "session/initiate",
  resumeSession: "session/resume",
  extendTrialPeriod: "ExtendTrail",
  getCountries: "GetCountries",
  inviteMSP: "UserRegistration",
  addProduct: "AddProduct",
  getColorPalette: 'GetColorPallet',
  createEditCustomColor: 'CreateEditCustomColor',
  deleteCustomColor: 'DeleteCustomColor',
  getPracticesTools: "GetPracticesTools",
  updateSecurityStackHeaderView: 'SubmitNotificationSettings',
  createMultipleIntegrationTechnologyToolV2: 'CreateMultipleIntegrationTechnologyToolV2',
  addIntegrationToMultipleTechnologiesForMSP: "AddIntegrationToMultipleTechnologiesForMSP",
  getProductsFromCategory: 'GetProductsFromCategory',
  updateStoreFrontProducts: 'UpdateStoreFrontProducts',
  getAllCategories: 'GetAllCategories',
  createProductCategory: 'CreateProductCategory',
  deleteProductCategory: 'DeleteProductCategory',
  getCategoriesSortOrder: 'GetCategoriesSortOrder',
  updateCategorySortOrder: 'UpdateCategorySortOrder',
  getTechnologySpend: 'GetTechnologySpend',
  updateCategorySortVisibility: 'UpdateCategorySortVisibility',
  resetCategoryToDefault: 'ResetCategoryToDefault',
  getClientAllSupplierManufacturer: 'GetClientAllSupplierManufacturer',
  getMSPAllSupplierManufacturer: 'GetMSPAllSupplierManufacturer',
}

export const API_DOMENS = {
  CC_API: 'CC_API',
  PSA_API: 'PSA_API',
  AttackSurfaceAPI: 'AttackSurfaceAPI',
  ObjectraAPI: 'ObjectraAPI',
  TechSpend: 'TechSpend',
  SB_API: 'SB_API',
  IPWhitelist_API: 'IPWhitelist_API',
}

export const PDF_API_PATHS = {
  secStackReport: `${PDF_API_URL}/sec-stack/portland-report/html`,
  secStackReportPDF: `${PDF_API_URL}/sec-stack/portland-report/pdf`,
  secStackReportByLinkId: `${PDF_API_URL}/sec-stack/portland-report-shared/html`,
  secStackReportPDFByLinkId: `${PDF_API_URL}/sec-stack/portland-report-shared/pdf`,
}